import { palette } from 'cds/styles';
import { FC } from 'react';
import styled from 'styled-components';

const Section3: FC = () => {
  return (
    <section>
      <L_Section3Container>
        200여 개의 기업이 클래스유를 통해
        <br />
        임직원에 교육을 제공하고 있습니다.
      </L_Section3Container>
    </section>
  );
};

const L_Section3Container = styled.div`
  padding-top: 0rem;
  padding-bottom: 7rem;
  text-align: center;
  font-size: 1.6rem;
  color: ${palette.grey50};
`;

export default Section3;
